import {CardContent as MUICardContent} from '@mui/material'

export const CardContent = MUICardContent
